import { Mode } from '../types/mode'

export const isMode = (mode: Mode) => mode === process.env.REACT_APP_MODE

export const hasMode = (modes: Mode[]) => modes.some(isMode)
